const sizesMap = {
    xs: '5px',
    ssm: '12px',
    sm: '15px',
    md: '30px',
    lg: '60px',
    xl: '120px',
    xxl: '150px',
}

export enum Sizes {
    xs = 'xs',
    ssm = 'ssm',
    sm = 'sm',
    md = 'md',
    lg = 'lg',
    xl = 'xl',
    xxl = 'xxl',
}

export const defaultSize = 'sm'

export const sizes = Object.keys(sizesMap)

export default sizesMap
